import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useEffect, useState } from 'react';
import Checkbox from '../../Checkbox.js';
import ExclusiveContent from '../../ExclusiveContent.js';
import Input from '../../Input.js';
import Well from '../../Well.js';
const CommunicationChannels = (props) => {
    const { heading, collector, lang } = props;
    const [eBoksId, setEBoksId] = useState(null);
    const [eBoksContentTypeId, setEBoksContentTypeId] = useState(null);
    const [eBoksSystemId, setEBoksSystemId] = useState(null);
    const updateCollector = useMutation((update) => collectorsAPI.update(collector.collectorId, update), {
        onSuccess: () => {
            q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
        },
        onError: (error) => {
            alert(error);
        },
    });
    useEffect(() => {
        if (eBoksId === null) {
            setEBoksId(collector.eBoksSetup?.eBoksId || null);
        }
        if (eBoksContentTypeId === null) {
            setEBoksContentTypeId(collector.eBoksSetup?.contentTypeId || null);
        }
        if (eBoksSystemId === null) {
            setEBoksSystemId(collector.eBoksSetup?.systemId || null);
        }
    }, [collector]);
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, heading),
        React.createElement(ExclusiveContent, null,
            React.createElement(Well, null,
                React.createElement("h3", null, "e-Boks setup"),
                React.createElement(Checkbox, { placeholder: 'e-Boks activated', onChange: (e) => {
                        updateCollector.mutate({
                            eBoksSetup: {
                                ...collector.eBoksSetup,
                                activated: e.target.checked,
                            },
                        });
                    }, checked: !!collector.eBoksSetup?.activated, disabled: !(collector.eBoksSetup?.contentTypeId &&
                        collector.eBoksSetup?.eBoksId &&
                        collector.eBoksSetup?.systemId) }),
                React.createElement(Input, { placeholder: 'e-Boks id (kundenummer)', onChange: (e) => setEBoksId(e.target.value), type: "number", value: eBoksId || '', button: eBoksId != collector.eBoksSetup?.eBoksId
                        ? {
                            value: '👍',
                            onClick: async () => {
                                try {
                                    await collectorsAPI.update(collector.collectorId, {
                                        eBoksSetup: {
                                            ...collector.eBoksSetup,
                                            eBoksId: eBoksId || undefined,
                                        },
                                    });
                                    q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
                                }
                                catch (error) {
                                    alert(error);
                                }
                            },
                        }
                        : undefined }),
                React.createElement(Input, { placeholder: 'Content type id (DOK)', onChange: (e) => setEBoksContentTypeId(e.target.value), type: "number", value: eBoksContentTypeId || '', button: eBoksContentTypeId != collector.eBoksSetup?.contentTypeId
                        ? {
                            value: '👍',
                            onClick: async () => {
                                try {
                                    await collectorsAPI.update(collector.collectorId, {
                                        eBoksSetup: {
                                            ...collector.eBoksSetup,
                                            contentTypeId: eBoksContentTypeId || undefined,
                                        },
                                    });
                                    q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
                                }
                                catch (error) {
                                    alert(error);
                                }
                            },
                        }
                        : undefined }),
                React.createElement(Input, { placeholder: 'System id', onChange: (e) => setEBoksSystemId(e.target.value), type: "number", value: eBoksSystemId || '', button: eBoksSystemId != collector.eBoksSetup?.systemId
                        ? {
                            value: '👍',
                            onClick: async () => {
                                try {
                                    await collectorsAPI.update(collector.collectorId, {
                                        eBoksSetup: {
                                            ...collector.eBoksSetup,
                                            systemId: eBoksSystemId || undefined,
                                        },
                                    });
                                    q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
                                }
                                catch (error) {
                                    alert(error);
                                }
                            },
                        }
                        : undefined })),
            React.createElement("br", null),
            React.createElement(Checkbox, { placeholder: lang.collectors.hideEmail, onChange: (e) => {
                    updateCollector.mutate({
                        hideEmail: e.target.checked,
                    });
                }, checked: collector.hideEmail }))));
};
export default CommunicationChannels;
//# sourceMappingURL=CommunicationChannels.js.map